import { RecordItems } from "@/services/getRecordsLibrary";
import { RecordingData } from "@/utils/indexedDBUtils";

export type RecordItemProp = {
  recordingId: string;
  title: string;
  date: string;
  duration: string;
  status: number;
  exports: {
    id: string;
    exportTitle: string;
    exportType: number;
    exportedDate: string;
    status: number;
  }[];
};

export type RecordListProps = {
  items: RecordItemProp[];
  currentPage: number;
  totalItems: number;
  pageSize: number;
};

export enum RecordStatusEnum {
  "NONE" = 0,
  "IN_PROGRESS" = 1,
  "DONE" = 2,
  "READY_TO_EDIT" = 3,
  "READY_TO_EXPORT" = 4,
  "FAILED" = 5,
  "RETRYING" = 6,
  "PAUSED" = 7,
  "RECORDING" = 8,
  "READY_FOR_RECORDING" = 9,
  "GENERATED" = 10,
}

export type DerivedMergeFlags = {
  isOnIndexDB: boolean;
  isOldData: boolean;
  isHashEqual: boolean | null;
  isFailedDifferentHash: boolean;
  isUploadInterrupted: boolean;
};

export type MergeDerivedFlagsParams = {
  backendItem: RecordItems["items"][number];
  localItem?: RecordingData;
  localHasNewPauseStructure: boolean;
};
